module.exports = __webpack_public_path__ + "img/alert.eeae131a.svg";